export default "<div *ngFor=\"let referral of referral$ | async; let i = index\">\r\n  {{referral.patientID}}\r\n</div>\r\n"